// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__FP1ul","info":"Panel_info__r-aPj","note":"Panel_note__bDem5","close":"Panel_close__yIIH1","btns":"Panel_btns__3QlwD","button":"Panel_button__qH1YF"};